import React from "react";
import "./index.css";

const Alert = (props) => {
  return (
    props.alert && (
      <div className={`alertMessage ${props.alert.type}`}>
        <p>
          <strong>{props.alert.type}</strong>: {props.alert.message}
        </p>
      </div>
    )
  );
};

export default Alert;
